import React, {useState,useEffect} from 'react';
import Participant from '../../../partials/Participant/Participant';
import './PeerFeedback.scss';


const PeerFeedback = props => {
    console.log("******PROPS*******");
    console.log(props);
    // console.log(Object.entries(props.selectedOption.feedback.peers))
    return <div className='peers-container'>
        {props.selectedOption && props.selectedOption.feedback.reactions.map((reaction, i) => {
            return <Participant 
                hasNameTag={false} 
                teamMember={props.people[reaction.person]} 
                scale={reaction.scale} size='small' 
            />
        })}
    </div>

}

export default PeerFeedback;